var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIllustrationCollaboration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M18 41h2v-2h-2z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E97025",
    d: "M14 13h2V8h-2zM28 45H16c-1.103 0-2-.897-2-2V29h2v14h12V30h2v13c0 1.103-.897 2-2 2M28 14h2V8h-2z",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 30h-9a3.004 3.004 0 01-2.789-4.105A3.006 3.006 0 018 23c0-1.381.938-2.547 2.211-2.895a3.006 3.006 0 012-4A3.004 3.004 0 0115 12l9.287.042L34.146 15H36v2l-2.287-.042L23.854 14H15a1.001 1.001 0 000 2v2h-2a1.001 1.001 0 000 2v2h-2a1.001 1.001 0 000 2h2v2a1.001 1.001 0 000 2h9v2",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M13 26h6v-2h-6zM13 22h6v-2h-6zM15 18h4v-2h-4zM24.236 34H20c-1.654 0-3-1.346-3-3v-2h2v2c0 .551.448 1 1 1h3.764l3.708-1.854L31.667 27H36v2h-3.667l-3.886 2.895L24.236 34M39 20h2v-2h-2zM67 16h5v-2h-5z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 30H37c-1.103 0-2-.897-2-2V16c0-1.103.897-2 2-2h14v2H37v12h13v2M66 30h6v-2h-6z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 36h-2l.042-2.287L66 23.853V15a1.001 1.001 0 00-2 0h-2v-2a1.001 1.001 0 00-2 0h-2v-2a1.001 1.001 0 00-2 0v2h-2a1.001 1.001 0 00-2 0v9h-2v-9a3.004 3.004 0 014.105-2.789A3.005 3.005 0 0157 8c1.381 0 2.548.938 2.895 2.211a3.005 3.005 0 014 2A3.004 3.004 0 0168 15l-.042 9.287L65 34.147V36",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E97025",
    d: "M54 19h2v-6h-2zM58 19h2v-6h-2zM62 19h2v-4h-2zM53 36h-2v-3.667l-2.895-3.886L46 24.236V20c0-1.654 1.346-3 3-3h2v2h-2c-.552 0-1 .449-1 1v3.764l1.854 3.708L53 31.667V36",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M60 41h2v-2h-2z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E97025",
    d: "M50 72h2v-6h-2zM52 50h-2V37c0-1.103.897-2 2-2h12c1.103 0 2 .897 2 2v12h-2V37H52v13M64 72h2v-7h-2z",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 66h-9v-2h9a1.001 1.001 0 000-2v-2h2a1.001 1.001 0 000-2h-2v-2a1.001 1.001 0 000-2h-2v-2a1.001 1.001 0 000-2h-8.854L46 53h-2v-2h1.854L56 48h9a3.004 3.004 0 012.789 4.105 3.006 3.006 0 012 4A3.006 3.006 0 0172 59a3.006 3.006 0 01-2.211 2.895A3.004 3.004 0 0167 66",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M61 62h6v-2h-6zM61 58h6v-2h-6zM61 54h4v-2h-4zM60 70h-4.236L51.4 67.8 47.667 65H44v-2h4.333l4.195 3.146L56.236 68H60c.552 0 1-.449 1-1v-2h2v2c0 1.654-1.346 3-3 3M39 56h2v-2h-2zM8 52h7v-2H8z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 66H29v-2h14V52H31v-2h12c1.103 0 2 .897 2 2v12c0 1.103-.897 2-2 2M8 66h5v-2H8z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 72a3.005 3.005 0 01-2.895-2.211 3.005 3.005 0 01-4-2A3.004 3.004 0 0112 65l.042-9.287L15 45.853V44h2l-.042 2.287L14 56.147V65a1.001 1.001 0 002 0h2v2a1.001 1.001 0 002 0h2v2a1.001 1.001 0 002 0v-2h2a1.001 1.001 0 002 0v-9h2v9a3.004 3.004 0 01-4.105 2.789A3.005 3.005 0 0123 72",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E97025",
    d: "M24 67h2v-6h-2zM20 67h2v-6h-2zM16 65h2v-4h-2zM31 63h-2v-2h2c.552 0 1-.449 1-1v-3.764l-1.854-3.708L27 48.333V44h2v3.667l2.895 3.886L34 55.764V60c0 1.654-1.346 3-3 3",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E97025",
    d: "M15 45h14v-2H15z",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }))));
}

export default SvgIconIllustrationCollaboration;